import { httpClient, addToOrderUrl, removeFromOrderUrl } from "../main";

export async function addToOrder(itemGuid) {
  return await httpClient.post(addToOrderUrl, {
    flooringFinderProductGuid: itemGuid,
  });
}

export async function removeFromOrder(itemGuid) {
  return await httpClient.post(removeFromOrderUrl, {
    flooringFinderProductGuid: itemGuid,
  });
}
